module.exports = __webpack_public_path__ + "img/roles.10a3020a.svg";